import React from "react";
import HistoricLineChart from "./HistoricLineChart";
import { parseNumber } from "src/lib/historyChart";

export default function HistoricConsumptions(props) {
  return (
    <HistoricLineChart
      title="Consumption Historic Graph"
      subject="consumption"
      history={props.historicConsumptions}
      parse={parseNumber}
      kind="numeric"
      unit="W"
      yLabel="Consumption (W)"
      startDate={props.startDate}
      endDate={props.endDate}
    />
  );
}
